var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.gallery)?_c('div',[_c('gallery-header',{attrs:{"returnPage":_vm.returnPage,"gallery":_vm.gallery}}),_c('div',{staticClass:"row",class:{ 'full-width': _vm.template_options.full_width }},[_c(_vm.gallery_template,{tag:"component",attrs:{"gallery":_vm.gallery}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }